import React, { useState } from 'react';
import { Send, Paperclip, Loader2 } from 'lucide-react';
export function ContactSupport() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  if (isSuccess) {
    return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center" data-id="element-1139">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4" data-id="element-1140">
          <Send className="h-6 w-6 text-green-600" data-id="element-1141" />
        </div>
        <h3 className="text-lg font-medium text-gray-900" data-id="element-1142">Message Sent!</h3>
        <p className="text-gray-500 mt-2 mb-6" data-id="element-1143">
          Our support team will get back to you within 24 hours.
        </p>
        <button onClick={() => setIsSuccess(false)} className="text-blue-600 hover:text-blue-700 font-medium text-sm" data-id="element-1144">
          Send another message
        </button>
      </div>;
  }
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-1145">
      <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-1146">
        Contact Support
      </h3>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1147">
        <div data-id="element-1148">
          <label className="block text-sm font-medium text-gray-700" data-id="element-1149">
            Subject
          </label>
          <select className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-1150">
            <option data-id="element-1151">Payment Issue</option>
            <option data-id="element-1152">Verification Help</option>
            <option data-id="element-1153">Technical Support</option>
            <option data-id="element-1154">Other</option>
          </select>
        </div>

        <div data-id="element-1155">
          <label className="block text-sm font-medium text-gray-700" data-id="element-1156">
            Message
          </label>
          <textarea rows={4} className="mt-1 block w-full shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm border-gray-300 rounded-md" placeholder="Describe your issue in detail..." required data-id="element-1157" />
        </div>

        <div className="flex items-center justify-between pt-2" data-id="element-1158">
          <button type="button" className="text-gray-500 hover:text-gray-700 flex items-center text-sm" data-id="element-1159">
            <Paperclip className="h-4 w-4 mr-2" data-id="element-1160" />
            Attach File
          </button>

          <button type="submit" disabled={isSubmitting} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50" data-id="element-1161">
            {isSubmitting ? <>
                <Loader2 className="animate-spin -ml-1 mr-2 h-4 w-4" data-id="element-1162" />
                Sending...
              </> : <>
                Send Message
                <Send className="ml-2 -mr-1 h-4 w-4" data-id="element-1163" />
              </>}
          </button>
        </div>
      </form>
    </div>;
}